<template>
  <div class="app-home pb-[6rem] max-w-screen-xl mx-auto">
    <div v-if="isLoading" class="wrapper-spinner">
      <ProgressSpinner />
    </div>
    <div
      class="flex flex-col md:flex-row  mb-[6rem] mx-10 lg:mx-auto p-10 bg-[#DB323E] justify-between rounded-xl"
    >
      <div class="wrapper-select flex flex-col">
        <label class="text-white text-xl mb-2"> Veicolo </label>
        <Dropdown
          v-model="selectedType"
          :options="type"
          optionLabel="name"
          emptyMessage="Opzioni non disponibili"
          placeholder="Seleziona"
          class="w-14rem dropdown"
          @change="onChangeType"
        />
      </div>
      <div class="wrapper-select flex flex-col">
        <label class="text-white text-xl mb-2"> Brand </label>
        <Dropdown
          v-model="selectedMaker"
          :options="brands"
          optionLabel="name"

          emptyMessage="Opzioni non disponibili"
          placeholder="Seleziona"
          class="w-14rem dropdown"
          @change="onChangeMaker"
        />
      </div>
      <div class="wrapper-select flex flex-col">
        <label class="text-white text-xl mb-2"> Modello </label>
        <Dropdown
          v-model="selectedModel"
          :options="models"
          optionLabel="name"
          emptyMessage="Opzioni non disponibili"
          placeholder="Seleziona"
          class="w-14rem dropdown"
          @change="onChangeModel"
        />
      </div>
      <div class="wrapper-select flex flex-col">
        <label class="text-white text-xl mb-2"> Motore </label>
        <Dropdown
          v-model="selectedTrim"
          :options="trims"
          optionLabel="name"
          emptyMessage="Opzioni non disponibili"
          placeholder="Seleziona"
          class="w-14rem dropdown"
          @change="onChangeTrim"
        />
      </div>
    </div>
    <section class="my-6">
      <div class="flex flex-col items-center">
        <h1 class="text-3xl font-semibold mb-10 mt-10 mx-10 lg:mx-auto lg:text-5xl text-white">
          Vuoi <span class="text-[#DB323E]">massimizzare</span> le prestazioni
          della <span class="text-[#DB323E]">tua auto</span> ?
        </h1>
      </div>
      <div class="divider"></div>
    </section>
    <div v-if="chartData">
      <div class="wrapper-data flex flex-col justify-center w-full">
        <h2 class="text-2xl font-bold mt-10 text-white text-center">
          Rimappatura centralina
        </h2>
        <div class="font-bold text-3xl text-white text-center">
          <span class="text-[#DB323E]">{{ selectedMaker.name }}</span>
          {{ selectedModel.name }} {{ selectedTrim.name }}
        </div>
      </div>
      <div class="flex mx-auto p-10">
        <div class="wrapper-charts flex flex-col flex-1 max-w-full">
          <div class="wrappre-tab-content flex flex-col lg:flex-row px-0 lg:px-10 items-end">
            <div
              class="flex flex-col mx-auto w-[90%] h-full lg:w-[50%]"

            >
              <div class="text-white text-2xl ps-[30px]">
                <!-- <b>Coppia da <span style="color:rgba(75, 192, 192, .8)">{{ this.dataCoppia?.data?.value }} {{ this.dataCoppia?.data?.unit }}</span> a <span class="text-[#DB323E]">{{ Math.round(Number(this.dataCoppia?.data?.value) * this.dataCoppia.perc) }} {{ this.dataCoppia?.data?.unit }}</span></b> -->
              </div>
              <Chart
                :type="'bar'"
                :data="chartData"
                :options="chartOptions"
                class="h-full w-full flex-1 flex pe-5"
              />
            </div>
            <div
              class=" w-[85%] mx-auto mt-10 lg:mt-0 lg:pt-0 lg:w-[48%] px-0 lg:px-10 flex-1 flex flex-col justify-between"
            >
              <div :class="this.selectedType.id !== 1 ? 'flex flex-col flex-1 justify-end':'flex flex-col flex-1 justify-between'" :style="this.selectedType.id !== 1 ? 'height:100%;margin-top:40px':''">
                <div class="flex relative flex-1 justify-between mb-[15px] pb-[5px] items-center" >
                  <div class="text-white">
                    <b class="text-[#DB323E] text-xl">Originale</b>
                  </div>
                  <div class="text-white w-[120px]" style="text-align:center;line-height: normal;">
                    <b class="text-[#00ff00] text-xl">
                      Mappa Dierrebi
                    </b>
                  </div>
                  <div class="absolute bottom-0 left-0 w-full h-[1px] bg-gradient-to-r from-[#DB323E] to-[#00ff00]"></div>
                </div>
                <div :class="this.selectedType.id !== 1 ? 'mb-[50px] flex flex-1 relative pb-[15px] mt-[10px] max-h-[130px] ':'flex flex-1 relative pb-[15px] mt-[10px] max-h-[130px] '">
                  <div
                    class="absolute bottom-0 left-0 w-full h-[10px] bg-gradient-to-r from-[#DB323E] to-[#00ff00]"
                  ></div>
                  <div class="flex flex-1 justify-between flex-col">
                    <div class="text-white font-semibold text-xl">Potenza</div>
                    <div class="text-[#DB323E] text-2xl">
                      <b>
                        <i>
                          {{ this.dataPotenza?.data?.value }}
                          {{ this.dataPotenza?.data?.unit }}
                        </i>
                      </b>
                    </div>
                  </div>
                  <div class="flex flex-1 justify-between flex-col text-right">
                    <div class="text-[#00ff00] font-semibold text-xl">

                      {{
                        this.calcDiff(this.dataPotenza?.data?.value,this.dataPotenza?.perc)
                      }}
                      {{ this.dataPotenza?.data?.unit }}
                    </div>
                    <div class="text-[#DB323E] text-2xl">
                      <b>
                        <i>
                          {{
                           this.calcPerc(this.dataPotenza?.data?.value,this.dataPotenza?.perc)
                          }}
                          {{ this.dataPotenza?.data?.unit }}
                        </i>
                      </b>
                    </div>
                  </div>
                </div>
                <div :class="this.selectedType.id !== 1 ? 'mb-[50px] flex flex-1 relative pb-[15px] mt-[10px] max-h-[130px] ':'flex flex-1 relative pb-[15px] mt-[10px] max-h-[130px] '">
                  <div
                    class="absolute bottom-0 left-0 w-full h-[10px] bg-gradient-to-r from-[#DB323E] to-[#00ff00]"
                  ></div>
                  <div class="flex flex-1 justify-between flex-col">
                    <div class="text-white font-semibold text-xl">Coppia</div>
                    <div class="text-[#DB323E] text-2xl">
                      <b>
                        <i>
                          {{ this.dataCoppia?.data?.value }}
                          {{ this.dataCoppia?.data?.unit }}
                        </i>
                      </b>
                    </div>
                  </div>
                  <div class="flex flex-1 justify-between flex-col text-right">
                    <div class="text-[#00ff00] font-semibold text-xl">
                      {{
                        this.calcDiff(this.dataCoppia?.data?.value, this.dataCoppia?.perc)
                      }}
                      {{ this.dataCoppia?.data?.unit }}
                    </div>
                    <div class="text-[#DB323E] text-2xl">
                      <b>
                        <i>
                          {{
                            this.calcPerc(this.dataCoppia?.data?.value,this.dataCoppia?.perc)
                          }}
                          {{ this.dataCoppia?.data?.unit }}
                        </i>
                      </b>
                    </div>
                  </div>
                </div>

                <div v-if="this.selectedType.id === 1" class="flex flex-1 relative pb-[15px] mt-[10px]">
                  <div
                    class="absolute bottom-0 left-0 w-full h-[10px] bg-gradient-to-r from-[#DB323E] to-[#00ff00]"
                  ></div>
                  <div class="flex flex-1 justify-between flex-col">
                    <div class="text-white font-semibold text-xl">Consumi</div>
                    <div class="text-[#DB323E] text-2xl">
                      <b>
                        <i>
                          {{ this.dataConsumi?.data?.value }}
                          {{ this.dataConsumi?.data?.unit }}
                        </i>
                      </b>
                    </div>
                  </div>
                  <div class="flex flex-1 justify-between flex-col text-right">
                    <div class="text-[#00ff00] font-semibold text-xl">

                      {{
                       this.calcDiff(this.dataConsumi?.data?.value,this.dataConsumi?.perc)
                      }}
                      {{ this.dataConsumi?.data?.unit }}
                    </div>
                    <div class="text-[#DB323E] text-2xl">
                      <b>
                        <i>
                          {{
                           this.calcPerc(this.dataConsumi?.data?.value,this.dataConsumi?.perc)
                          }}
                          {{ this.dataConsumi?.data?.unit }}
                        </i>
                      </b>
                    </div>
                  </div>
                </div>
                <div v-if="this.selectedType.id === 1" class="flex flex-1 relative pb-[15px] mt-[10px]">
                  <div
                    class="absolute bottom-0 left-0 w-full h-[10px] bg-gradient-to-r from-[#DB323E] to-[#00ff00]"
                  ></div>
                  <div class="flex flex-1 justify-between flex-col">
                    <div class="text-white font-semibold text-xl">
                      Accelerazione
                    </div>
                    <div class="text-[#DB323E] text-2xl">
                      <b>
                        <i>
                          {{ this.dataAccellerazione?.data?.value }}
                          {{ this.dataAccellerazione?.data?.unit }}
                        </i>
                      </b>
                    </div>
                  </div>
                  <div class="flex flex-1 justify-between flex-col text-right">
                    <div class="text-[#00ff00] font-semibold text-xl">

                      {{
                        this.calcDiff(this.dataAccellerazione?.data?.value,this.dataAccellerazione?.perc,true)
                      }}
                      {{ this.dataAccellerazione?.data?.unit }}
                    </div>
                    <div class="text-[#DB323E] text-2xl">
                      <b>
                        <i>
                          {{
                            this.calcPerc(this.dataAccellerazione?.data?.value,this.dataAccellerazione?.perc,true)
                          }}
                          {{ this.dataAccellerazione?.data?.unit }}
                        </i>
                      </b>
                    </div>
                  </div>
                </div>
                <div v-if="this.selectedType.id === 1" class="flex flex-1 relative pb-[15px] mt-[10px]">
                  <div
                    class="absolute bottom-0 left-0 w-full h-[10px] bg-gradient-to-r from-[#DB323E] to-[#00ff00]"
                  ></div>
                  <div class="flex flex-1 justify-between flex-col">
                    <div class="text-white font-semibold text-xl">Velocità</div>
                    <div class="text-[#DB323E] text-2xl">
                      <b>
                        <i>
                          {{ this.dataVelocita?.data?.value }}
                          {{ this.dataVelocita?.data?.unit }}
                        </i>
                      </b>
                    </div>
                  </div>
                  <div
                    v-if="this.dataVelocita?.data?.value !== 'N/A'"
                    class="flex flex-1 justify-between flex-col text-right"
                  >
                    <div class="text-[#00ff00] font-semibold text-xl">

                      {{
                        this.calcDiff(this.dataVelocita?.data?.value,this.dataVelocita?.perc)
                      }}
                      {{ this.dataVelocita?.data?.unit }}
                    </div>
                    <div class="text-[#DB323E] text-2xl">
                      <b>
                        <i>
                          {{
                            this.calcPerc(this.dataVelocita?.data?.value,this.dataVelocita?.perc)
                          }}
                          {{ this.dataVelocita?.data?.unit }}
                        </i>
                      </b>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrapper-info-costi">
        <div class="flex flex-col justify-center items-center">
          <div class="wrapper-data w-full px-10 flex-1 flex flex-col">
            <h4
              class="text-5xl font-semibold mb-10 mt-20 text-white text-center"
            >
              <span class="text-[#DB323E]">Costi</span> dell'intervento
            </h4>
            <div class="divider"></div>
            <div class="flex mt-10">
              <div class="flex flex-1 justify-between flex-col text-center">
                <span class="text-white font-semibold text-xl"
                  >Solo mappatura</span
                >
                <span class="text-[#DB323E] text-4xl"
                  ><b>{{ this.price }}€* </b></span
                >
              </div>
              <div class="flex flex-1 justify-between flex-col text-center">
                <span class="text-white font-semibold text-xl"
                  >Mappatura + banco prova</span
                >
                <span class="text-[#DB323E] text-4xl">
                  <b>{{ this.price + 100 }}€*</b>
                </span>
              </div>
            </div>
            <small class="mt-3 text-white text-end"
              ><i>*prezzo iva inclusa</i></small
            >
          </div>
        </div>
      </div>
      <div class="wrapper-note p-10">
        <p>
          <b>Note:</b>
        </p>
        <p class="text-white mt-10 opacity-30" style="line-height: 12px">
          <br />
          <small
            ><i>
              Tutti i nostri software e file mantengono inalterati gli standard
              di emissioni antinquinamento dei veicoli.
              <br />
              ¹Il dati di potenza e coppia dichiarati sono un’indicazione basata
              sui risultati ottenuti sul nostro banco prova in fase di sviluppo,
              ovvero con auto in condizioni meccaniche perfette, carburante
              premium e temperature dell’aria ottimali. I valori possono subire
              variazioni di +/- 5% sulla potenza complessiva in base alle
              condizioni di prova sull’auto del cliente (temperatura aria,
              qualità carburante utilizzato, stato meccanico della vettura). I
              nostri software vengono prodotti singolarmente sulla base delle
              richieste del cliente ed anche questo può influire sul valori di
              incremento effettivi.
              <br />
              ²L’opzione test su banco prova comprende una serie di acquisizioni
              su uno dei nostri banchi a rulli. Le prove vengono effettuate
              prima e dopo l’intervento di modifica software gestione motore, in
              modo da poter comparare i risultati ottenuti con i valori
              originali. I test vengono sempre svolti con almeno 5 lanci sia con
              auto originale che successivamente alla modifica o fino a quando
              necessario per determinare correttamente la potenza. Anche un
              eventuale aggiustamento della calibrazione prevede una nuova
              sessione di test senza maggiorazioni sul prezzo concordato.
              Eventuali lanci su banco oltre i 5 previsti non comportano costi
              aggiuntivi e possono essere eseguiti a discrezione dei tecnici. In
              caso di installazione di stage avanzati è possibile richiedere che
              i test vengano svolti anche in fase intermedia per valutare il
              miglioramento legato ad upgrades meccanici, questa opzione
              comporta un aumento del preventivo da concordare in fase di
              prenotazione.
            </i>
          </small>
          <br />
        </p>
      </div>
    </div>
  </div>
</template>


<script>
import { defineComponent, toRaw } from "vue";
import Papa from "papaparse";
import Dropdown from "primevue/dropdown";

import ProgressSpinner from "primevue/progressspinner";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Button from "primevue/button";

import Chart from "primevue/chart";

export default defineComponent({
  name: "Home",
  components: {
    Dropdown,
    TabView,
    TabPanel,
    Button,
    Chart,
    ProgressSpinner,
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js Frontview component 2",
      activeIndex: 0,
      active: 0,
      selectedType: null,
      selectedMaker: null,
      selectedModel: null,
      selectedTrim: null,
      specifications: [],
      brands: [],
      models: [],
      trims: [],
      type: [
        { name: "Auto", id: 1 },
        // { name: "bus", id: 6},
        // { name: "trailer", id: 4},
        { name: "Camion", id: 5},
        { name: "Furgoni", id: 2},
        // { name: "truck trailer", id: 3},
        { name: "Moto", id: 20 },
      ],
      chartData: null,
      dataPotenza: null,
      dataCoppia: null,
      dataConsumi: null,
      dataAccellerazione: null,
      dataVelocita: null,
      isBenzina: false,
      isTurbo: false,
      chartOptions: null,
      chartRadarData: null,
      chartRadarOptions: null,
      price: null,
      normalizedData: null,
      boostCsv: null,
      csvContent: null,
      isLoading: false,
    };
  },
  watch: {
    specifications: {
      handler(newVal) {
        if (newVal) {
        }
      },
      immediate: true,
    },
    csvContent: {
      handler(newVal) {
        if (newVal) {
          this.readCsv(toRaw(newVal));
        }
      },
      immediate: true,
    },
  },
  methods: {
    calcDiff(value, perc, isAccellerazione = false) {
      if(value){

        if (value.indexOf("/") === -1) {
          return (isAccellerazione ? '-' : '+') + Number( Number(value) * perc - Number(value)).toFixed(2)
        } else {
          // Separare i valori di coppia e giri
          let parts = value.split(" ");
          let values = parts[0].split("/");

          // Convertire i valori in numeri
          let nmValue = parseFloat(values[0]);
          let rpmValue = parseFloat(values[1]);

          // Moltiplicare ciascun valore per il fattore percentuale
          let newNmValue = (nmValue * perc)-nmValue;
          let newRpmValue = (rpmValue * perc)-rpmValue;

          // Ricombinare i valori nel formato originale
          let newValue = `${isAccellerazione ? '-':'+'}${newNmValue.toFixed(2)}/+${newRpmValue.toFixed(2)}`;

          if(newValue.length > 2){

            return newValue
          }
          return ""
        }
      }
      return ""
    },
    calcPerc(value, perc, isAccellerazione = false) {
      if(!value) return "N/A"
      if (value.indexOf("/") === -1) {
        if(isAccellerazione){
          return Number(Number(value) - ((Number(value) * perc)  - Number(value))).toFixed(2)
        }
        return Number( Number(value) * perc).toFixed(2)
      } else {
        // Separare i valori di coppia e giri
        let parts = value.split(" ");
        let values = parts[0].split("/");

        // Convertire i valori in numeri
        let nmValue = parseFloat(values[0]);
        let rpmValue = parseFloat(values[1]);

        // Moltiplicare ciascun valore per il fattore percentuale
        let newNmValue = (nmValue * perc);
        let newRpmValue = (rpmValue * perc);

        // Ricombinare i valori nel formato originale
        let newValue = `${newNmValue.toFixed(2)}/${newRpmValue.toFixed(2)}`;

        if(newValue.length > 1){

          return newValue
        }
        return ""
      }
    },
    loadCsv(url) {
      fetch(url)
        .then((response) => response.text())
        .then((data) => {
          Papa.parse(data, {
            header: true,
            complete: (results) => {
              this.csvContent = {};
              this.csvContent = results.data.filter(
                (row) => row["Colonna1"] !== null && row["Colonna1"]?.length > 0
              );
            },
            error: (error) => {
              console.error("Error parsing CSV:", error);
            },
          });
        })
        .catch((error) => {
          console.error("Error fetching CSV:", error);
        });
    },
    checkSpecialPerc(id, specs) {
      if (!this.csvContent) {
        this.isLoading = true;
        // this.loadCsv(this.boostCsv)
        this.loadCsv("/public/regole.csv");
      } else {
        this.readCsv(this.csvContent);
      }
    },
    readCsv(content) {
      this.hasSpecialPerc = false;
      this.specialPerc = null;
      this.isLoading = false;
      this.price = null;
      // // console.log("readCsv", Number(this.selectedTrim.id), this.selectedType.id);
      if (this.selectedType.id===1) {
        const specialPercData = content.filter((row,i) => {
          // // console.log("row", row, Number(row.id_car_trim),Number(this.selectedTrim.id),Number(row.id_car_trim) === Number(this.selectedTrim.id));
          return Number(row.id_car_trim) === Number(this.selectedTrim.id)
        });
        if (specialPercData.length > 0) {
          // // console.log("specialPercData", specialPercData);
          this.hasSpecialPerc = true;
          switch (specialPercData[0]?.Colonna1) {
            case "perc_5":
              this.specialPerc = 1.05;
              break;
            case "perc_10":
              this.specialPerc = 1.1;
              break;
            case "perc_40":
              this.specialPerc = 1.4;
              break;
          }
        }
      }

      let potenza = toRaw(this.specifications).filter((item) => {
        return (
          Number(item.id_car_specification) === 14 ||
          Number(item.id_car_specification) === 15 ||
          Number(item.id_car_specification) === 56 ||
          Number(item.id_car_specification) === 1558 ||
          Number(item.id_car_specification) === 1559 ||
          // Number(item.id_car_specification) === 586 ||
          Number(item.id_car_specification) === 587 ||
          Number(item.id_car_specification) === 588 ||
          Number(item.id_car_specification) === 380 ||
          Number(item.id_car_specification) === 996
        );
      });



      const carProperties = [
        { id: 20, label: "Numero di cilindri" },
        { id: 15, label: "Regime di potenza massima" },
        { id: 14, label: "Potenza del motore" },
        { id: 16, label: "Coppia massima" },
        { id: 32, label: "Velocità massima" },
        { id: 33, label: "Accelerazione a 100 km/h" },
        { id: 12, label: "Tipo di motore" },
        { id: 46, label: "Tipo di sovralimentazione" },
        { id: 50, label: "Consumo di carburante in città per 100 km" },
        { id: 51, label: "Consumo di carburante in autostrada a 100 km" },
        { id: 52, label: "Consumo nel ciclo misto 100 km" },
        { id: 13, label: "Cilindrata" },
        { id: 12, label: "Cilindrata" },
      ];
      const motoProperties = [
        {id: 1021, label: 'Coppia'}
      ]

      const truckPoropertiies = [
        {id: 380, label: 'tipo di motore'},
        {id: 382, label: 'coppia'},
      ]

      let vehicleProps = null

      switch (this.selectedType.id) {
        case 1:
          vehicleProps = carProperties
          break;
        case 20:
          vehicleProps = motoProperties
          break;
        default:
          vehicleProps = truckPoropertiies
          break;
      }

      let preparedData = vehicleProps?.map((item) => {
        let property = toRaw(this.specifications).filter(
          (spec) => Number(spec.id_car_specification) === Number(item.id)
        );


        if (this.selectedType.id === 20 || this.selectedType.id !== 1) {
          this.price = this.getPrice();
        }else {

          if ((item.id === 12 || item.id === 590 || item.id === 383) && property) {
            this.isBenzina =
              property[0]?.value.toLowerCase().indexOf("benzina") > -1;
          }
          if (item.id === 46 && property) {
            this.isTurbo = property[0]?.value.toLowerCase().indexOf("turbo") > -1;
            // console.log("isTurbo", property[0]?.value, this.isTurbo);
          }
          let price = null;
          if (item.id === 13 && property && this.price === null) {

            this.price = this.getPrice(Number(property[0]?.value));
          }
        }


        if (!property.length) {
          // console.log(
          //   "property null",
          //   item,
          //   property,
          //   toRaw(this.specifications)
          // );
        }

        return {
          ...item,
          name: property[0]?.name,
          value: property[0]?.value
            ? String(property[0]?.value).replace(",", ".")
            : "",
          unit: property[0]?.unit,
          isValid: property.length > 0,
        };
      });

      if (this.selectedType.id === 6) {
        // console.log("preparedData camion", this.selectedType.id,toRaw(this.specifications));
        const preparedDataValue = toRaw(this.specifications)[0].coppia
        const preparedDataPotenza = toRaw(this.specifications)[0].motore_potenza
        potenza = [
          {
            id: 380,
            name: 'Tipo di motore',
            value: preparedDataPotenza.split(" ")[0],
            unit: preparedDataPotenza.split(" ")[1],
          }
        ]
        preparedData = [
          {
            id: 382,
            name: 'Coppia',
            value: preparedDataValue.split(" ")[0],
            unit: preparedDataValue.split(" ")[1],
          }
        ]
      }

      const dataPotenza = {
        data: potenza[0],
        perc: this.hasSpecialPerc
          ? this.specialPerc
          : this.getPotenzaEnhanchedPerc(),
      };

      const dataCoppia = {
        data: preparedData.filter((item) => item?.id === 16  || item?.id === 1021 || item?.id === 589 || item?.id === 1582 || item?.id === 1583 || item?.id === 382
        )[0],
        perc: this.hasSpecialPerc
          ? this.specialPerc
          : this.getCoppiaEnhanchedPerc(),
      };

      const dataConsumi = {
        data: preparedData.filter(
          (item) => item?.id === 50 || item?.id === 51 || item?.id === 52 || item?.id === 621
        )[0],
        perc: this.getConsumiEnhanchedPerc(),
      };
      const dataAccellerazione = {
        data: preparedData.filter((item) => item?.id === 33)[0],
        perc: this.getAccellerazioneEnhanchedPerc(),
      };
      // // console.log("dataAccellerazione", dataAccellerazione);
      const dataVelocita = {
        data: preparedData.filter((item) => item?.id === 32)
          ? preparedData.filter((item) => item?.id === 32)[0]
          : null,
        perc: this.getVelocitaEnhanchedPerc(),
      };

      this.dataPotenza = dataPotenza;
      this.dataCoppia = dataCoppia;
      this.dataConsumi = dataConsumi;
      this.dataAccellerazione = dataAccellerazione;
      this.dataVelocita = dataVelocita;

      const originalData = {
        potenza: [
          Number((dataPotenza.data?.value)?.split("/")[0]),
          Math.round(Number((dataPotenza.data?.value)?.split("/")[0]) * dataPotenza.perc),
        ],
        coppia: [
          Number((dataCoppia.data?.value).split("/")[0]),
          Math.round(Number((dataCoppia.data?.value)?.split("/")[0]) * dataCoppia.perc),
        ],
        consumi: [
          Number(dataConsumi.data?.value),
          Math.round(Number(dataConsumi.data?.value) * dataConsumi.perc),
        ],
        accelerazione: [
          Number(dataAccellerazione.data?.value),
          Number(dataAccellerazione.data?.value) - (Math.round( Number(dataAccellerazione.data?.value) * dataAccellerazione.perc ) - Number(dataAccellerazione.data?.value))
        ],
        velocita: [
          Number(dataVelocita.data?.value),
          Math.round(Number(dataVelocita.data?.value) * dataVelocita.perc),
        ],
      };
      // console.log("originalData", originalData);

      // Configurazione del grafico
      const labels = [
        "Potenza",
        "Coppia",
        "Consumi",
        "Accelerazione",
        "Velocità",
      ];

      const originalDataChart = [
        originalData.potenza[0],
        originalData.coppia[0],
        Number(originalData.consumi[0]) * 10,
        Number(originalData.accelerazione[0]) * 10,
        originalData.velocita[0],
      ]

      const enhachedDataChart = [
        originalData.potenza[1],
        originalData.coppia[1],
        Number(originalData.consumi[1]) * 10,
        Number(originalData.accelerazione[1]) * 10,
        originalData.velocita[1],
      ]


      if(this.selectedType.id !== 1){
        labels.splice(2, 3)
        originalDataChart.splice(2, 3)
        enhachedDataChart.splice(2, 3)
      }


      const data = {
        labels: labels,
        datasets: [
          {
            label: "Originale",
            data: originalDataChart,
            backgroundColor: "rgba(219, 50, 62,1)",
            borderColor: "rgba(219, 50, 62, 1)",
            borderWidth: 1,
          },
          {
            label: "Rimappata",
            data: enhachedDataChart,
            backgroundColor: "rgba(0, 255, 0, 1)",
            borderColor: "rgba(0, 255, 0, 1)",
            borderWidth: 1,
          },
        ],
      };
      this.chartData = data;

      this.chartOptions = this.setChartOptions();
      // return data;
    },
    getPrice(cilindrata) {
      if(this.selectedType.id !== 20 && this.selectedType.id !== 1){
        return 850
      }
      if(this.selectedType.id == 20){
        return 550
      }
      const range = [
        {
          min: 0,
          max: 1699,
          range: "A",
          price: this.isBenzina ? 350 : 400,
        },
        {
          min: 1700,
          max: 2499,
          range: "B",
          price: this.isBenzina ? 500 : 500,
        },
        {
          min: 2500,
          max: 2999,
          range: "C",
          price: this.isBenzina ? 550 : 550,
        },
        {
          min: 3000,
          max: 9999,
          range: "D",
          price: this.isBenzina ? 600 : 600,
        },
      ];
      // console.log("price", range, cilindrata);
      const price = range.filter((item) => {
        return item.min <= Number(cilindrata) && item.max >= Number(cilindrata);
      });
      let overprice = 0;
      switch (toRaw(this.selectedMaker).name) {
        case "Ferrari":
        case "Lamborghini":
        case "Porsche":
        case "Aston Martin":
        case "Maserati":
        case "McLaren":
          overprice = this.isTurbo ? 200 : 100;
          break;
        default:
          overprice = 0;
      }

      // console.log("price", price[0].price, overprice, this.selectedMaker);
      if (price.length > 0) {
        return price[0].price + overprice;
      }
      return "N/A";
    },
    getPotenzaEnhanchedPerc() {
      if (this.isBenzina) {
        if (this.isTurbo) {
          return 1.2;
        } else {
          return 1.12;
        }
      } else {
        return 1.2;
      }
    },
    getCoppiaEnhanchedPerc() {
      if (this.isBenzina) {
        if (this.isTurbo) {
          return 1.18;
        } else {
          return 1.08;
        }
      } else {
        return 1.18;
      }
    },
    getConsumiEnhanchedPerc() {
      if (this.isBenzina) {
        if (this.isTurbo) {
          return 1.08;
        } else {
          return 1.08;
        }
      } else {
        return 1.15;
      }
    },
    getAccellerazioneEnhanchedPerc() {
      if (this.isBenzina) {
        if (this.isTurbo) {
          return 1.08;
        } else {
          return 1.08;
        }
      } else {
        return 1.15;
      }
    },
    getVelocitaEnhanchedPerc() {
      if (this.isBenzina) {
        if (this.isTurbo) {
          return 1.05;
        } else {
          return 1.05;
        }
      } else {
        return 1.05;
      }
    },
    reorderData(data) {
      const clone = data.sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      );
      return clone;
    },
    onChangeType(e, value) {
      // console.log("onChangeType", e, value);
      this.chartData = null;
      this.selectedType = e.value;
      this.brands = [];
      this.models = [];
      this.trims = [];
      this.fetchData("getMakes", e.value.id)
        .then((response) => response.json())
        .then((result) => (this.brands = this.reorderData(result.data)))
        .catch((error) => console.error(error));
    },
    onChangeMaker(e, value) {
      this.chartData = null;
      // console.log("onChangeMaker", e);
      this.selectedMaker = e.value;
      this.models = [];
      this.trims = [];
      this.fetchData("getModels", e.value.id)
        .then((response) => response.json())
        .then((result) => (this.models = result.data))
        .catch((error) => console.error(error));
    },
    onChangeModel(e, value) {
      this.chartData = null;
      // console.log("onChangeModel", e);
      this.selectedModel = e.value;

      this.trims = [];
      this.fetchData("getTrims", e.value.id)
        .then((response) => response.json())
        .then((result) => (this.trims = result.data))
        .catch((error) => console.error(error));
    },
    onChangeTrim(e, value) {
      this.chartData = null;
      // console.log("onChangeTrim", e);
      this.selectedTrim = e.value;

      this.fetchData("getSpecifications", e.value.id)
        .then((response) => response.json())
        .then((result) => {
          // console.log("result", result.data);
          const data = JSON.parse(result.data);
          this.boostCsv = data.boost_csv;
          this.specifications = data.specs;
          this.checkSpecialPerc(e.value.id, data.specs);
        })
        .catch((error) => console.error(error));
    },
    fetchData(action, value) {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        action,
        value,
        type: this.selectedType.id,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      const baseUrl =
        String(window.location.href).indexOf("localhost") > -1
          ? "http://dierrebi.local"
          : "";
      // console.log("baseUrl", baseUrl);
      return fetch(baseUrl + "/wp-json/car2db/v1/form", requestOptions);
    },
    setChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: "y",

        scales: {
          x: {
            ticks: {
              color: "white",
            },
          },
          y: {
            ticks: {
              color: "white",
            },
            beginAtZero: true,
            max: 100, // Normalizzati in percentuale
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            // Disable the on-canvas tooltip
            enabled: false,

            external: function (context) {
              // Tooltip Element
              let tooltipEl = document.getElementById("chartjs-tooltip");

              // Create element on first render
              if (!tooltipEl) {
                tooltipEl = document.createElement("div");
                tooltipEl.id = "chartjs-tooltip";
                tooltipEl.innerHTML = "<table></table>";
                document.body.appendChild(tooltipEl);
              }

              // Hide if no tooltip
              const tooltipModel = context.tooltip;
              if (tooltipModel.opacity === 0) {
                tooltipEl.style.opacity = 0;
                return;
              }

              // Set caret Position
              tooltipEl.classList.remove("above", "below", "no-transform");
              if (tooltipModel.yAlign) {
                tooltipEl.classList.add(tooltipModel.yAlign);
              } else {
                tooltipEl.classList.add("no-transform");
              }

              function getBody(bodyItem) {
                return bodyItem.lines;
              }

              // Set Text
              if (tooltipModel.body) {
                const titleLines = tooltipModel.title || [];
                const bodyLines = tooltipModel.body.map(getBody);

                let innerHtml = "<thead>";

                titleLines.forEach(function (title) {
                  innerHtml += "<tr><th>" + title + "</th></tr>";
                });
                innerHtml += "</thead><tbody>";

                bodyLines.forEach(function (body, i) {
                  // console.log("body", body);
                  // console.log("titleLines", titleLines);
                  const content = body[0].split(":");
                  const colors = tooltipModel.labelColors[i];
                  let style = "";
                  // let style = "background:" + colors.backgroundColor;
                  // style += "; border-color:" + colors.borderColor;
                  // style += "; border-width: 2px";
                  let span = '<span style="' + style + '">';
                  switch (titleLines[0]) {
                    case "Consumi":
                      span +=
                        content[0] +
                        ": <i style='color:" +
                        colors.backgroundColor +
                        ";font-weight: bold;'>" +
                        Number(content[1]) / 10 +
                        "</i>";
                      break;
                    case "Accelerazione":
                      span +=
                        content[0] +
                        ": <i style='color:" +
                        colors.backgroundColor +
                        ";font-weight: bold;'>" +
                        Number(content[1]) / 10 +
                        "</i>";
                      break;
                    default:
                      span +=
                        content[0] +
                        ": <i style='color:" +
                        colors.backgroundColor +
                        ";font-weight: bold;'>" +
                        content[1] +
                        "</i>";
                      break;
                  }
                  span += "</span>";
                  innerHtml += "<tr><td>" + span + "</td></tr>";
                });
                innerHtml += "</tbody>";

                let tableRoot = tooltipEl.querySelector("table");
                tableRoot.innerHTML = innerHtml;
              }

              const position = context.chart.canvas.getBoundingClientRect();
              // const bodyFont = Chart.helpers.toFont(
              //   tooltipModel.options.bodyFont
              // );

              // Display, position, and set styles for font
              tooltipEl.style.transition = "all 0.3s";
              tooltipEl.style.borderRadius = "5px";
              tooltipEl.style.padding = "10px";
              tooltipEl.style.background = "rgba(255,255,255, 0.7)";
              tooltipEl.style.opacity = 1;
              tooltipEl.style.position = "absolute";
              tooltipEl.style.left =
                position.left + window.pageXOffset + tooltipModel.caretX + "px";
              tooltipEl.style.top =
                position.top + window.pageYOffset + tooltipModel.caretY + "px";
              // tooltipEl.style.font = bodyFont.string;
              tooltipEl.style.padding =
                tooltipModel.padding + "px " + tooltipModel.padding + "px";
              tooltipEl.style.pointerEvents = "none";
            },
          },
        },
      };
    },
  },
});
</script>

